import { connect } from 'react-redux';

import NotificationsDropdown from './NotificationsDropdown';
import {
  isLoadingNotificationsSelector,
  notificationsListSelector,
  unreadCountSelector,
} from '../../../../store/selectors/notifications';
import { fetchNotificationsAction } from '../../../../store/actions/notifications';

const mapStateToProps = state => ({
  notifications: notificationsListSelector(state),
  isLoading: isLoadingNotificationsSelector(state),
  unreadCount: unreadCountSelector(state),
});

const mapDispatchToProps = {
  fetchNotifications: fetchNotificationsAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsDropdown);
